module.exports = __webpack_public_path__ + "img/case-logo-44.228a2cac.png";